module.exports = __webpack_public_path__ + "static/img/new-mirror-ico.7933388d.png";